<script>
    import ProjectField from "../../models/participaid/ProjectField.js";
    import Accounting from "../../models/participaid/Accounting.js";

    export let contributor;
    export let model; // inputValue
    export let field; // project field
    export let style;
    export let showMultiplierResult = true;

    $: value = Accounting.contributionFinancialValue(model, field, contributor);
    $: isTime = ProjectField.isTimeField(field);
    $: isMonetary = !isTime;
</script>

<span class="contribution-value" class:isTime class:isMonetary {style}>
    {#if !model}
        ...
    {:else if value}
        <strong>€ {value.toFixed(2)}</strong>
        {#if showMultiplierResult && field && field.multiplier && field.multiplier != 1}
            <div>
                <span class="multiplier">
                    x{field.multiplier}
                </span>
                <span> = </span>
                <span class="total">
                    {Accounting.contributionFinancialValueMultiplied(model, field, contributor)}
                </span>
            </div>
        {/if}
    {:else if !contributor.hourlySalary}
        missing variable: contributor hourly salary
    {/if}
</span>

<style>
    strong {
        font-size: 20px;
        font-weight: bold;
    }
</style>